<script>
  import "leaflet";
  //liblary
  import axios from "axios";
  import { session } from "../js/notif.js";
  let settings;
  session.subscribe((value) => {
    settings = value;
  });

  $: listArea = [];
  $: listMarker = [];
  function loadShopList(cat = false) {
    let area = "";
    if (localStorage["area"]) {
      area = localStorage["area"];
    }
    if (cat) {
      category = cat;
    }
    axios
      .get(settings.url + "/sipade/listtoko", {
        params: {
          authorization: settings.token,
          area: area,
        },
      })
      .then(function (response) {
        listMarker = response.data.data;
        listArea = response.data.area;
        loadMapAll();
      });
  }
  if (settings) {
    loadShopList();
  }

  function loadMapAll() {
    loadMap();
  }
  let uid = Math.random().toString(36).substring(2);
  let L = window.L;
  let div = "map-" + uid;

  function loadMap() {
    document.getElementById("contmap-" + uid).innerHTML =
      "<div id='map-" + uid + "' style='width: 100%; height: 100%;'></div>";
    console.log(listArea);
    let map = L.map(div).setView([listArea.lat, listArea.lang], 13);

    var aIcon = new L.Icon({
      iconUrl:
        "https://api.geoapify.com/v1/icon/?type=material&color=%23fd7319&size=large&icon=store&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0",
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    var bIcon = new L.Icon({
      iconUrl:
        "https://api.geoapify.com/v1/icon/?type=material&color=%23198fd7&size=large&icon=store&textSize=small&apiKey=1b48259b810e48ddb151889f9ea58db0",
      shadowUrl:
        "https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.3.4/images/marker-shadow.png",
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41],
    });

    L.tileLayer("https://{s}.tile.osm.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
      attribution:
        '&copy; <a href="https://osm.org/copyright">OpenStreetMap</a> contributors',
      id: "PositionPicker",
      noWrap: true,
    }).addTo(map);

    if (listMarker.length > 0) {
      listMarker.forEach((m) => {
        var category = "Kategori Produk ";
        m.category?.forEach((cat) => {
          if (cat.value != 0) {
            category +=
              " ,<a href='/belanja/" +
              m.data.domain +
              "/c/" +
              cat.alias +
              "'>" +
              cat.title +
              "</a>";
          }
        });

        if (m.owner == true) {
          L.marker([m.data.latitude, m.data.longtitude], { icon: aIcon })
            .addTo(map)
            .bindPopup(
              "<p class='font-light'><a href='./belanja/" +
                m.data.domain +
                "'><b class='text-sm font-bold'>" +
                m.data.nameShop +
                "</b></a><br />" +
                category +
                "<br/><br/><span class='italic'>" +
                m.data.address_name +
                "<br/>" +
                m.area.desa +
                " " +
                m.area.kec +
                " " +
                m.area.kab +
                " </span></p>"
            );
        } else {
          L.marker([m.data.latitude, m.data.longtitude], { icon: bIcon })
            .addTo(map)
            .bindPopup(
              "<p class='font-light'><a href='./belanja/" +
                m.data.domain +
                "'><b class='text-sm font-bold'>" +
                m.data.nameShop +
                "</b></a><br />" +
                category +
                "<br/><br/><span class='italic'>" +
                m.data.address_name +
                "<br/>" +
                m.area.desa +
                " " +
                m.area.kec +
                " " +
                m.area.kab +
                " </span></p>"
            );
        }
      });
    }
  }
</script>

<div
  class="relative w-full"
  id="contmap-{uid}"
  style="height: calc(100vh - 200px);"
/>
